import React from 'react';
import { AdminAnnouncementsPage } from '../../../components/admin/AdminAnnoucementsPage';

export function AdminAnnouncementsRoute() {
  return (
    <AdminAnnouncementsPage />
  );
}